const images = {
    view: [
    {
      id: 1,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/1.jpg',
      name: "Churdhar"
    },
    {
      id: 2,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/2.jpg',
      name: "Hassan Valley Green Forest"
    },
    {
      id: 3,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/3.jpg',
      name: "Hassan Valley Green Forest"
    },
    {
      id: 4,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/4.jpg',
      name: "Hassan Valley Green Forest",
      
    },
    {
      id: 5,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/5.jpg',
      name: "Hassan Valley Green Forest"
    },
    {
      id: 6,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/6.jpg',
    },
    {
      id: 7,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/7.jpg',
      name: "Hassan Valley Green Forest"
    },
    {
      id: 8,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/8.jpg',
      name: "Hassan Valley Green Forest"
    },
    {
      id: 9,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/9.jpg',
      name: "Hassan Valley Green Forest"
    },
    {
      id: 10,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/10.jpg',
    },
    {
      id: 11,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/11.jpg',
    },
    {
      id: 12,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/12.jpg',
    },
    {
      id: 13,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/13.jpg',
      name: "Hassan Valley Green Forest"
    },
    {
      id: 14,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/14.jpg',
    },
    {
      id: 15,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/15.jpg',
    },
  ],
  work: [
    {
      id: 16,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/1.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 17,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/2.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 18,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/3.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 19,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/4.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 20,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/5.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 21,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/6.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 22,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/7.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 23,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/8.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 24,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/9.jpg',
      date:"10<sup>th</sup> Jan 2025"
    },
    {
      id: 25,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/10.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 26,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/11.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 27,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/12.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 28,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/13.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 29,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/14.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 30,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/15.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 31,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/16.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 32,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/17.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 33,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/18.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 34,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/19.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 35,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/20.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 36,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/21.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 37,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/22.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 38,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/23.jpg',
      date:"22<sup>nd</sup> Mar 2025"
    },
    {
      id: 39,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/24.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 40,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/25.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 41,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/26.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 42,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/27.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 43,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/28.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 44,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/29.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 45,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/30.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 46,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/31.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 47,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/32.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 48,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/33.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 49,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/34.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 50,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/35.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 51,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/36.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 52,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/37.jpg',
      date: "17<sup>th</sup> Apr 2025"
    },
    {
      id: 53,
      url: 'https://d2r3u9c7j9d9om.cloudfront.net/gallery/workinprogress/38.jpg',
      date: "17<sup>th</sup> Apr 2025"
    }    
  ]
}





export default images;